import type { RootState } from '@/store';

import type { ContractCategory, TrialStatusItem } from '../../types';

export const selectItemDoMarcoMaisGrave = (state: RootState): TrialStatusItem | null => {
  const marco = state.contractsTrialStatus.marcoMaisGrave;
  if (!marco) return null;
  return state.contractsTrialStatus.itens.find((item) => item.marco === marco) ?? null;
};

export const selectTrialStatusPorCategoria =
  (category: ContractCategory) =>
  (state: RootState): TrialStatusItem | null =>
    state.contractsTrialStatus.itens.find((item) => item.category === category) ?? null;
